import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HorizontalRuleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"horizontal_rule"}/>
}
